"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var LunrSearch_1 = __importDefault(require("./LunrSearch"));
/**
 * Search client wraps search engine for in-browser search features.
 *
 * - Load index from json.
 * - Perform search query.
 */


var SearchClient =
/** @class */
function () {
  function SearchClient(config) {
    var _this = this;

    this.search = function (queryString) {
      var filtered = _this.filter(queryString);

      return _this.searchEngine.search(filtered);
    }; // Remove the search engine specific charactors on customize search.


    this.filter = function (qs) {
      return qs.replace(/:|\$|#|@|!|\^|\*|\+|-|~|%/g, ' ');
    };

    this.validateIndex = function (index) {
      if (!index) {
        return false;
      }

      var expires = index.expires;
      return Date.now() <= expires;
    };

    this.getLocalIndex = function () {
      var rawIndex = localStorage.getItem('search:index') || '{}';

      try {
        return JSON.parse(rawIndex);
      } catch (error) {
        return false;
      }
    };

    this.loadIndex = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var index, indexUrl, response, expires, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 3,, 4]);

              index = this.getLocalIndex();
              if (!(!index || !this.validateIndex(index))) return [3
              /*break*/
              , 2];
              indexUrl = process.env.BODILESS_SEARCH_INDEX_URL || '/default.idx';
              return [4
              /*yield*/
              , axios_1.default.get(indexUrl)];

            case 1:
              response = _a.sent();
              expires = process.env.BODILESS_SEARCH_EXPIRES || 86400;
              index = __assign({
                expires: Date.now() + Number(expires)
              }, response.data);
              localStorage.setItem('search:index', JSON.stringify(index));
              _a.label = 2;

            case 2:
              this.searchEngine.loadIndex(index.idx);
              this.loadPreviews(index.preview);
              return [3
              /*break*/
              , 4];

            case 3:
              error_1 = _a.sent();
              console.log('Failed to load search index file.');
              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.loadPreviews = function (previews) {
      _this.searchEngine.loadPreviews(previews);
    };

    this.searchEngine = config && config.searchEngine ? config.searchEngine : new LunrSearch_1.default();
  }

  SearchClient.prototype.setSearchEngine = function (searchEngine) {
    this.searchEngine = searchEngine;
  };

  return SearchClient;
}();

exports.default = SearchClient;